import { render, staticRenderFns } from "./LuExciseTaxTypes.vue?vue&type=template&id=129b66fa&"
import script from "./LuExciseTaxTypes.vue?vue&type=script&lang=js&"
export * from "./LuExciseTaxTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports